<template>
  <div class="event-chart">
    <doughnut-week-numbers v-on:add-event="emitAddEvent" />
    <doughnut-chart
      :chart-data="chartdata"
      chart-id="doughnut-chart"
      css-classess="doughnut-chart"
      :options="options"
      :styles="eventStyles"
    ></doughnut-chart>
    <div id="chartjs-tooltip" :style="tooltip.style" @click="clickTooltip()">
      <div>
        <!-- {{ tooltip.heading }} <br /> -->
        {{ tooltip.body }}
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import { mapState } from "vuex";
import DoughnutChart from "@/components/DoughnutChart";
import DoughnutWeekNumbers from "@/components/DoughnutWeekNumbers";

export default {
  components: {
    DoughnutChart,
    DoughnutWeekNumbers
  },
  props: {
    year: {
      type: Number,
    },
  },
  data() {
    return {
      chartdata: null,
      options: null,
      months: [
        { id: "01", month: "Tammikuu" },
        { id: "02", month: "Helmikuu" },
        { id: "03", month: "Maaliskuu" },
        { id: "04", month: "Huhtikuu" },
        { id: "05", month: "Toukokuu" },
        { id: "06", month: "Kesäkuu" },
        { id: "07", month: "Heinäkuu" },
        { id: "08", month: "Elokuu" },
        { id: "09", month: "Syyskuu" },
        { id: "10", month: "Lokakuu" },
        { id: "11", month: "Marraskuu" },
        { id: "12", month: "Joulukuu" }
      ],
      color: null,
      tooltip: {
        active: true,
        heading: "",
        body: "",
        style: {
          left: "0px",
          top: "0px",
          opacity: 0
        }
      },
      used: false,
      events: [],
      sortedEvents: [],
      companyId: null,
      unsubscribe: null,
      activated: false,
    };
  },
  computed: {
    ...mapState(["user", "company"]),

    eventStyles() {
      return {
        position: "relative"
      };
    }
  },
  watch: {
    year() {
      this.initChart();
    }
  },
  destroyed() {
    if(this.unsubscribe != null) {
      this.unsubscribe();
    }
  },
  created() {
    if(this.company == null) {
      return;
    }
    this.unsubscribe = db.collection(`companies/${this.company.id}/events`).onSnapshot(snapshot => {
      this.events = [];
      snapshot.forEach(doc => {
        let event = doc.data();
        event.id = doc.id;
        this.events.push(event);
      });
      this.initChart();
    });
  },
  methods: {
    parseMonthStrings(obj) {
      obj.start = obj.start.split(".").join("");
      obj.end = obj.end.split(".").join("");
      let startObj = this.months.filter(item => {
        return item.id === obj.start.substr(2, 2);
      })[0];
      obj.startMonth = startObj.month;
      let endObj = this.months.filter(item => {
        return item.id === obj.end.substr(2, 2);
      })[0];

      obj.endMonth = endObj.month;
      return obj;
    },
    activateEvents(event) {
      if (!event.startDate && !event.endDate) {
        event.startDate = this.createDate(event.start);
        event.endDate = this.createDate(event.end);
      }
      event.pieColor = event.category.background;
      // this.createPieDataset(event);
      event = this.parseMonthStrings(event);
      event.parsed = true;
      this.sortedEvents.push(event);
      this.sortedEvents = this.sortedEvents.sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
    },
    createDate(str) {
      let arr = str.split(".");
      let d = parseInt(arr[0], 10);
      let m = parseInt(arr[1], 10) - 1;
      let y = parseInt(arr[2], 10);
      return new Date(y, m, d);
    },
    countDays(start, end) {
      let day = 24 * 60 * 60 * 1000;
      if (!end) {
        end = new Date(start.getFullYear(), 0, 0);
      }
      let days =
        Math.floor(Math.abs((end.getTime() - start.getTime()) / day)) + 1;
      // days = Math.floor(days / 30) * 30;
      return days;
    },
    getDayOfYearFromDate(date) {
      var start = new Date(date.getFullYear(), 0, 0);
      var diff = date - start;
      var oneDay = 1000 * 60 * 60 * 24;
      var day = Math.floor(diff / oneDay);
      return day;
    },
    createPieData() {
      let eventsByCategory = {};
      // let total = this.countDays(event.startDate, event.endDate);
      // let start = this.countDays(event.startDate);

      let selectedYear = this.year; // TODO: haetaan tähän vuosikellon asetuksista mitä vuotta tarkastellaan
      let yeardays = selectedYear % 4 === 0 ? 366 : 365; // Yksinkertainen karkausvuoden tarkistus, hajoaa vuonna 2100 :-)
      let chartEvents = [...this.events];

      chartEvents = chartEvents.filter(event => {
        const startYear = event.startDate.getFullYear();
        const endYear = event.endDate.getFullYear();
        return startYear == selectedYear || startYear < selectedYear && endYear >= selectedYear;
      });

      // Laitetaan eventteihin alku- ja loppupäivä numerona
      chartEvents = chartEvents.map(event => {
        event.chartStartDate = new Date(event.startDate.getTime());
        event.chartEndDate = new Date(event.endDate.getTime());

        if(event.chartStartDate.getFullYear() < selectedYear) {
          event.chartStartDate.setMonth(0);
          event.chartStartDate.setDate(1);
        }
        
        event.dayStart = this.getDayOfYearFromDate(event.chartStartDate) - 1;
        
        if(event.chartEndDate.getFullYear() > selectedYear) {
          event.chartEndDate.setMonth(11);
          event.chartEndDate.setDate(31);
        }

        event.dayEnd = this.getDayOfYearFromDate(event.chartEndDate);
        event.dayLength = event.dayEnd - event.dayStart;
        return event;
      });


      chartEvents.sort((a, b) => a.startDate - b.startDate);

      // Tallennetaan eventit yhteiseen objektiin jaoteltuna kategorioittain
      chartEvents.map(event => {
        if (!eventsByCategory[event.category.title]) {
          eventsByCategory[event.category.title] = [];
        }
        eventsByCategory[event.category.title].push(event);
      });

      const makeEmpty = (start, end) => {
        return {
          bgColor: "#ffffff",
          val: end - start,
          label: "no label"
        };
      };

      this.eventsByCategory = eventsByCategory;

      // Käydään läpi kategoriat, yritetään saada datasetille useampi
      // tapahtuma jos mahtuu ja luodaan näistä datasetit
      Object.keys(eventsByCategory).map(cat => {
        let valueData = [];
        let catEvents = eventsByCategory[cat];
        let catEventsTemp = [];
        let currentDay = 0;

        // Jos löytyy tapahtuma, joka menee rinkulalla päällekäin
        // tallennetaan se temp-arrayhin ja loopataan tätä uudestaan

        for (let i = 1; i > 0; i--) {
          // console.log(cat + " uusi kierros");
          // console.table(catEvents);
          catEvents.map(event => {
            if (event.dayStart < currentDay) {
              catEventsTemp.push(event);
              return;
            }
            if (event.dayStart > currentDay) {
              valueData.push(makeEmpty(currentDay, event.dayStart));
            }
            valueData.push({
              val: event.dayLength,
              bgColor: event.pieColor,
              startDate: event.startDate,
              endDate: event.endDate,
              label: event.title
            });
            currentDay = event.dayEnd;
          });

          if (currentDay < yeardays) {
            valueData.push(makeEmpty(currentDay, yeardays));
          }

          let backgroundColor = valueData.map(v => v.bgColor);
          let data = valueData.map(v => v.val);

          let dataset = {};
          dataset.data = [];
          dataset.borderColor = "#f5f5f5";
          dataset.borderWidth = [1, 1, 1];
          dataset.data = data;
          // dataset.label = catEvents[0].title;
          // dataset.label = "testi";
          dataset.titles = valueData.map(v => v.label);
          dataset.datalabelszzz = {
            labels: {
              // index: {
              //   align: "end",
              //   anchor: "end",
              //   color: function(ctx) {
              //     return ctx.dataset.backgroundColor;
              //   },
              //   font: { size: 18 },
              //   formatter: function(value, ctx) {
              //     return ctx.active ? "index" : "#" + (ctx.dataIndex + 1);
              //   },
              //   offset: 8,
              //   opacity: function(ctx) {
              //     return ctx.active ? 1 : 0.5;
              //   }
              // },
              name: {
                align: "top",
                font: { size: 16 },
                formatter: function(value, ctx) {
                  return ctx.active
                    ? "name"
                    : ctx.chart.data.labels[ctx.dataIndex];
                }
              }
              // value: {
              //   align: "bottom",
              //   backgroundColor: function(ctx) {
              //     var value = ctx.dataset.data[ctx.dataIndex];
              //     return value > 50 ? "white" : null;
              //   },
              //   borderColor: "white",
              //   borderWidth: 2,
              //   borderRadius: 4,
              //   color: function(ctx) {
              //     var value = ctx.dataset.data[ctx.dataIndex];
              //     return value > 50 ? ctx.dataset.backgroundColor : "white";
              //   },
              //   formatter: function(value, ctx) {
              //     return ctx.active ? "value" : Math.round(value * 1000) / 1000;
              //   },
              //   padding: 4
              // }
            }
          };

          dataset.backgroundColor = backgroundColor;
          dataset.hoverBackgroundColor = backgroundColor;
          this.chartdata.datasets.push(dataset);

          if (catEventsTemp.length > 0) {
            currentDay = 0;
            catEvents = catEventsTemp;
            catEventsTemp = [];
            valueData = [];
            i++;
          }
        }
      });

      this.updatePie();
    },
    updatePie() {
      this.options.cutoutPercentage =
        100 - Object.keys(this.eventsByCategory).length * 10;
    },
    initChart() {
      this.chartdata = {
        labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
        datasets: []
      };

      const _this = this;
      this.options = {
        tooltips: {
          enabled: false,
          custom: function(tooltip) {
            // console.log("tooltip", tooltip);
            // console.log("this", this);

            // Tooltip Element
            var tlEl = document.getElementById("chartjs-tooltip");
            var tooltipEl = _this.tooltip;

            // Hide if no tooltip
            if (tooltip.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // // Set caret Position
            tlEl.classList.remove("above", "below", "no-transform");
            if (tooltip.yAlign) {
              tlEl.classList.add(tooltip.yAlign);
            } else {
              tlEl.classList.add("no-transform");
            }

            // function getBody(bodyItem) {
            //   return bodyItem.lines;
            // }

            // Set Text
            if (tooltip.body) {
              // var titleLines = tooltip.title || [];
              // var bodyLines = tooltip.body.map(getBody);

              // let innerHtml = "testi " + Math.random();

              let dp = tooltip.dataPoints[0];

              let innerHtml =
                _this.chartdata.datasets[dp.datasetIndex].titles[dp.index];

              if (innerHtml === "no label") {
                tooltipEl.style.opacity = 0;
              } else {
                _this.tooltip.style.opacity = 1;
              }

              // titleLines.forEach(function(title) {
              //   innerHtml += "<tr><th>" + title + "</th></tr>";
              // });
              // innerHtml += "</thead><tbody>";

              // bodyLines.forEach(function(body, i) {
              //   var colors = tooltip.labelColors[i];
              //   var style = "background:" + colors.backgroundColor;
              //   style += "; border-color:" + colors.borderColor;
              //   style += "; border-width: 2px";
              //   var span =
              //     '<span class="chartjs-tooltip-key" style="' +
              //     style +
              //     '"></span>';
              //   innerHtml += "<tr><td>" + span + body + "</td></tr>";
              // });
              // innerHtml += "</tbody>";

              _this.tooltip.body = innerHtml;
            }

            let positionY = this._chart.canvas.offsetTop;
            let positionX = this._chart.canvas.offsetLeft;

            _this.tooltip.style.left = positionX + tooltip.caretX + "px";
            _this.tooltip.style.top = positionY + tooltip.caretY + "px";
          }
          // callbacks: {
          //   label: function(tooltipItem, data) {
          //     let label = data.datasets[tooltipItem.datasetIndex].label;
          //     return label;
          //   }
          // }
        },
        responsive: true,
        cutoutPercentage: 20,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        rotation: -0.5 * Math.PI,
        animation: {
          duration: 0
        }
      };

      this.events.map(event => {
        this.activateEvents(event);
      });
      this.createPieData();
      return this.events;
    },
    emitAddEvent(param) {
      this.$emit("add-event", param);
    },
    clickTooltip() {
      console.log("click");
    }
  }
};
</script>

<style lang="scss">
.event-chart {
  position: relative;
  max-width: 50rem;
  background-image: url(/images/months.svg);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding: 8%;
  z-index: 0;
  @include bp(md) {
    max-width: 100rem;
  }
}
#doughnut-chart {
  margin: 0px auto 0;
}
#chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  padding: 5px 15px;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}
</style>
